import React from "react";
import { Card, CardHeader, CardBody, Col } from "reactstrap";
import DataTable from "react-data-table-component";
import { capitalize, formatDate } from "../../Common/CommonFunction";
import Spinner from "../../Common/Spinner";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux"; // Import useDispatch and useSelector hooks
import {
  formatExperienceOutput,
  generateSlug,
  unslugAndCapitalize,
} from "../../Common/CommonFunction";
import NoDataFound from "../../Common/NoDataFound";
import { Edit2, Trash2, Eye, Copy, Users } from "react-feather";
import { customStyles } from "../../../Constant";
const JobDataTable = () => {




  // Retrieve data from the Redux store using useSelector hook
  const dashboardReducerdData = useSelector((state) => state.dashboardReducer);

  console.log("dashboardReducerdData55", dashboardReducerdData);
  const getStatusColor = (status) => {
    // Implement your logic to determine the badge color based on status
    // For example:
    switch (status) {
      case "ACTIVE":
        return "badge-light-success";
      case "ON_HOLD":
        return "badge-light-primary";
      case "UNDER_REVIEW":
        return "badge-light-info";
      case "DRAFT":
        return "badge-light-warning";
      case "CLOSED":
        return "badge-light-danger";
      default:
        return "badge-light-primary";
    }
  };
  let activejobsData = [];

  // Check if dashboard data is available and not loading
  if (
    dashboardReducerdData &&
    !dashboardReducerdData.isLoading &&
    dashboardReducerdData.data &&
    dashboardReducerdData.data.data &&
    dashboardReducerdData.data.data.active_jobs
  ) {
    activejobsData = dashboardReducerdData.data.data.active_jobs;
  }

  // const tableColumns = [
  //   {
  //     name: "#",
  //     cell: (row, index) => index + 1,
  //     width: "60px",
  //     // sortable: true,
  //     center: false,
  //   },
  //   {
  //     name: "Job Title",
  //     // sortable: true,
  //     center: false,
  //     width: "15%",
  //     cell: (row) =>
  //       row.job_name ? (
  //         <Link
  //           to={`${process.env.PUBLIC_URL}/recruiter/job_details/${generateSlug(
  //             row.job_name,
  //             row.job_location,
  //             formatExperienceOutput(
  //               row.work_experience_min,
  //               row.work_experience_max
  //             ).replace("-", "-to-"),
  //             row.job_id
  //           )}`}
  //           title={"View Job"}
  //         >
  //           {capitalize(row.job_name)}
  //         </Link>
  //       ) : (
  //         "-"
  //       ),
  //   },
  //   {
  //     name: "Location",
  //     width: "15%",
  //     cell: (row) => capitalize(row.job_location) || "-",
  //     // sortable: true,
  //     center: false,
  //   },
  //   {
  //     name: "Experience",
  //     width: "15%",
  //     cell: (row) => {
  //       const experienceOutput = formatExperienceOutput(
  //         row.work_experience_min,
  //         row.work_experience_max
  //       );
  //       return experienceOutput !== "N/A" ? experienceOutput : "-";
  //     },
  //     // sortable: false,
  //     center: true,
  //   },
  //   {
  //     name: "Created At",
  //     cell: (row) => formatDate(row.created_at) || "-",
  //     // sortable: true,
  //     center: false,
  //     width: "18%",
  //   },
  //   {
  //     name: "Applications",
  //     width: "17%",
  //     // sortable: false,
  //     center: true,
  //     cell: (row) =>
  //       row.applied_candidate_count ? (
  //         <Link
  //           to={`${process.env.PUBLIC_URL
  //             }/recruiter/job_applications/${generateSlug(
  //               row.job_name,
  //               row.job_location,
  //               formatExperienceOutput(
  //                 row.work_experience_min,
  //                 row.work_experience_max
  //               ).replace("-", "-to-"),
  //               row.job_id
  //             )}`}
  //         >
  //           {row.applied_candidate_count}
  //         </Link>
  //       ) : (
  //         0
  //       ),
  //   },
  //   {
  //     name: "Status",
  //     width: "11%",
  //     // sortable: false,
  //     center: true,
  //     cell: (row) => (
  //       <span className={`badge ${getStatusColor(row.job_status)}`}>
  //         {unslugAndCapitalize(row.job_status)}
  //       </span>
  //     ),
  //   },
  // ];

  const tableColumns = [
    {
      name: "#",
      cell: (row, index) => index + 1,
      width: "60px", // A fixed width is perfect for the index column
    },
    {
      name: "Job Title",
      sortable: false,
      grow: 3, // Allow this primary column to take the most available space
      minWidth: '180px', // Set a minimum width to prevent it from becoming too small
      cell: (row) =>
        row.job_name ? (
          // Wrapper div is crucial for reliable text-overflow ellipsis
          <div
            style={{
              width: '100%',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            title={capitalize(row.job_name)} // The tooltip shows the full title on hover
          >
            <Link
              to={`${process.env.PUBLIC_URL}/recruiter/job_details/${generateSlug(
                row.job_name,
                row.job_location,
                formatExperienceOutput(
                  row.work_experience_min,
                  row.work_experience_max
                ).replace("-", "-to-"),
                row.job_id
              )}`}
            // No style needed on the link itself
            >
              {capitalize(row.job_name)}
            </Link>
          </div>
        ) : (
          "-"
        ),
    },
    {
      name: "Location",
      sortable: false,
      grow: 2, // Give this column more space than others, but less than the title
      minWidth: '140px',
      cell: (row) => capitalize(row.job_location) || "-",
    },
    {
      name: "Experience",
      sortable: false,
      center: true,
      grow: 1.5,
      minWidth: '120px',
      cell: (row) => {
        const experienceOutput = formatExperienceOutput(
          row.work_experience_min,
          row.work_experience_max
        );
        return experienceOutput !== "N/A" ? experienceOutput : "-";
      },
    },
    {
      name: "Created At",
      sortable: false,
      grow: 1.5,
      minWidth: '120px',
      cell: (row) => formatDate(row.created_at) || "-",
    },
    {
      name: "Applications",
      sortable: false,
      center: true,
      grow: 1, // A standard grow factor is fine for a number
      minWidth: '110px',
      cell: (row) =>
        row.applied_candidate_count ? (
          <Link
            to={`${process.env.PUBLIC_URL
              }/recruiter/job_applications/${generateSlug(
                row.job_name,
                row.job_location,
                formatExperienceOutput(
                  row.work_experience_min,
                  row.work_experience_max
                ).replace("-", "-to-"),
                row.job_id
              )}`}
          >
            {row.applied_candidate_count}
          </Link>
        ) : (
          0
        ),
    },
    {
      name: "Status",
      sortable: false,
      center: true,
      grow: 1,
      minWidth: '110px', // Enough space for status badges like "Under Review"
      cell: (row) => (
        <span className={`badge ${getStatusColor(row.job_status)}`}>
          {unslugAndCapitalize(row.job_status)}
        </span>
      ),
    },
  ];

  return (
    <Card>
      <CardHeader className="card-no-border ">
        <div className="header-top">
          <h5>Active Jobs</h5>
          {activejobsData.length >= 1 && (
            <div className="card-header-right-icon">
              <Link to={`${process.env.PUBLIC_URL}/recruiter/manage_jobs`}>
                View All
              </Link>
            </div>
          )}
        </div>
      </CardHeader>
      <CardBody className="px-0 py-3 pt-0">

        <div className="table-container">
          <DataTable
            responsive
            customStyles={customStyles}
            striped={true}
            columns={tableColumns}
            data={activejobsData}
            //  pagination
            //   paginationServer
            //   paginationPerPage={10}
            selectableRowsHighlight
            selectableRowsOnClick
            progressPending={dashboardReducerdData.isLoading}
            progressComponent={<Spinner />}
            noDataComponent={<NoDataFound message={"No active jobs found"} />}
          /></div>
      </CardBody>
    </Card>
  );
};

export default JobDataTable;
